import { Avatar, Dropdown, MenuProps, Switch } from "antd";
import { useThemeMode } from "antd-style";
import { useTDAuthentication } from "auth/AuthenticationProvider";
const packageJson = require("../../package.json");

const currentVersion = packageJson.version;

const UserAvatar = () => {
  const { logoutUser, webDUser } = useTDAuthentication();
  const { themeMode, setThemeMode } = useThemeMode();
  const onLogout = () => {
    logoutUser?.(); 
    sessionStorage.removeItem("recoveryEmailPrompted");
  };

  const avatarMenu: MenuProps = {
    items: [
      // {
      //   key: "theme",
      //   type: "item",
      //   label: (
      //     <Switch
      //       checkedChildren="dark"
      //       unCheckedChildren="light"
      //       defaultValue={themeMode === "dark"}
      //       onChange={(checked, e) => {
      //         setThemeMode(checked ? "dark" : "light");
      //         e.stopPropagation();
      //       }}
      //     />
      //   )
      // },
      // {
      //   key: "divider",
      //   type: "divider"
      // },
      {
        key: "signout",
        type: "item",
        label: "Sign Out",
        onClick: onLogout,
        style:{textAlign:"center"}
      },
      {
        key: "email",
        type: "group",
        label: (webDUser?.user.mail),
        style:{textAlign:"center", fontSize:".75rem"}
      },
      {
        key:"version",
        type:"group",
        label:(currentVersion),
        style:{textAlign:"center", fontSize:".75rem"}
      }
    ]
  };
  return (
    <Dropdown menu={avatarMenu} trigger={["click"]} placement="bottomLeft">
      <div role="none" onClick={e => e.preventDefault()}>
        <Avatar className="avatar">{webDUser?.shortName()}</Avatar>
      </div>
    </Dropdown>
  );
};
export default UserAvatar;
